import React from 'react';
import Translation from '../translation/translation';

function FSFNotAvailableLightBoxContent({productType}) {
    return (
        <div className="fsf-na-light-box__content fsf-na-light-box-content">
            <div className="progress-list">
                <p className="progress-list__item progress-list-item progress-list-item--active">
                    <strong className="progress-list-item__headline">
                        <Translation translationKey="fsf-moto-light-box-progress-first-headline"/>
                    </strong>
                    <Translation translationKey="fsf-not-available-light-box-progress-first-text"/>
                </p>
                <p className="progress-list__item progress-list-item">
                    <strong className="progress-list-item__headline">
                        <Translation translationKey="fsf-not-available-light-box-progress-second-headline"
                                     placeholder={{'product-type': productType + 's'}}/>
                    </strong>
                    <Translation translationKey="fsf-moto-light-box-progress-second-text"/>
                </p>
                <p className="progress-list__item progress-list-item">
                    <strong className="progress-list-item__headline">
                        <Translation translationKey="fsf-not-available-light-box-progress-third-headline"
                                     placeholder={{'product-type': productType + 's'}}/>
                    </strong>
                    <Translation translationKey="fsf-not-available-light-box-progress-third-text"
                                 placeholder={{'product-type': productType + 's'}}/>
                </p>
            </div>

            <div className="fsf-na-light-box-content__call-us">
                <a
                    className="fsf-na-light-box-content__cta"
                    href="http://support.tyroola.com.au/en/support/tickets/new"
                    target="_blank"
                >
                    <Translation translationKey="fsf-moto-light-box-cta-text"/>
                </a>
            </div>
        </div>
    );
}

FSFNotAvailableLightBoxContent.propTypes = {
    productType: PropTypes.string.isRequired,
};

export {FSFNotAvailableLightBoxContent};
